import React from 'react';

import { CommonPropTypes } from '../IconTypes';

const LinkedIn: React.FC<CommonPropTypes> = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width='19'
      height='19'
      viewBox='0 0 19 19'
      fill='none'
    >
      <path
        fill='currentColor'
        d='M16.4161 0C16.9603 0 17.4823 0.216193 17.8671 0.60102C18.2519 0.985847 18.4681 1.50778 18.4681 2.05201V16.4161C18.4681 16.9603 18.2519 17.4823 17.8671 17.8671C17.4823 18.2519 16.9603 18.4681 16.4161 18.4681H2.05201C1.50778 18.4681 0.985847 18.2519 0.60102 17.8671C0.216193 17.4823 0 16.9603 0 16.4161V2.05201C0 1.50778 0.216193 0.985847 0.60102 0.60102C0.985847 0.216193 1.50778 0 2.05201 0H16.4161ZM15.9031 15.9031V10.4653C15.9031 9.57817 15.5507 8.72741 14.9234 8.10014C14.2962 7.47287 13.4454 7.12048 12.5583 7.12048C11.6862 7.12048 10.6705 7.654 10.178 8.45429V7.31542H7.31542V15.9031H10.178V10.8449C10.178 10.0549 10.8141 9.40847 11.6041 9.40847C11.9851 9.40847 12.3504 9.55981 12.6198 9.82919C12.8892 10.0986 13.0405 10.4639 13.0405 10.8449V15.9031H15.9031ZM3.9809 5.70459C4.43805 5.70459 4.87648 5.52299 5.19973 5.19973C5.52299 4.87648 5.70459 4.43805 5.70459 3.9809C5.70459 3.02672 4.93509 2.24695 3.9809 2.24695C3.52103 2.24695 3.07999 2.42964 2.75481 2.75481C2.42964 3.07999 2.24695 3.52103 2.24695 3.9809C2.24695 4.93509 3.02672 5.70459 3.9809 5.70459ZM5.40705 15.9031V7.31542H2.56501V15.9031H5.40705Z'
      />
    </svg>
  );
};

export default LinkedIn;
